import { CommonModule } from '@angular/common';
import { Component, HostListener } from '@angular/core';
import { DsIconButtonV2Component, DsIconComponent, DsIconName } from '@customdesignsystem';
import { ModalService } from '@services/modal/modal.service';

interface PiInvalidezTipo {
  title: string;
  description: string;
}

interface PiInvalidezPaso {
  label: string;
  icon: DsIconName;
}

/**
 * Modal “¿Qué es la Pensión por Invalidez?” — Figma (pasos del trámite).
 */
@Component({
  selector: 'app-pi-modal-que-es-pension',
  standalone: true,
  imports: [CommonModule, DsIconComponent, DsIconButtonV2Component],
  templateUrl: './pi-modal-que-es-pension.component.html',
  styleUrls: ['./pi-modal-que-es-pension.component.scss'],
})
export class PiModalQueEsPensionComponent {
  isScrolled = false;

  readonly tipos: PiInvalidezTipo[] = [
    {
      title: 'Invalidez parcial',
      description:
        'Pérdida de entre 50% y dos tercios de la capacidad de trabajo. Se reevalúa cada tres años.',
    },
    {
      title: 'Invalidez total',
      description: 'Pérdida de al menos dos tercios de la capacidad de trabajo. Es definitiva.',
    },
  ];

  readonly pasos: PiInvalidezPaso[] = [
    { label: '1. Inicia tu solicitud', icon: 'EditDocument' },
    { label: '2. Evaluación de Comisión Médica', icon: 'MedicalServices' },
    { label: '3. Recibe tu calificación', icon: 'MarkEmailRead' },
    { label: '4. Resultado de dictamen', icon: 'Gavel' },
    { label: '5. Pago de pensión', icon: 'AttachMoney' },
  ];

  constructor(private readonly modalService: ModalService) {}

  @HostListener('document:keydown.escape')
  onEscapeKey(): void {
    this.cerrar();
  }

  cerrar(): void {
    this.modalService.closeModal();
  }

  onScroll(event: Event): void {
    const target = event.target as HTMLElement;
    this.isScrolled = target.scrollTop > 0;
  }
}
